import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { SocketIO } from '../../core'
import { IOSocketContext } from './SIOSocket'

/**
 * SocketIO join room
 * usage : <SIOBidding callback={this.onMessage} />
 *
 * @date 2020-01-28
 * @export
 * @class SIOBidding
 * @extends {React.Component}
 */
export class SIOBidding extends React.Component {
  static propTypes = {
    callback: PropTypes.func.isRequired,
  }

  static contextType = IOSocketContext

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { callback } = this.props
    const socket = this.context
    socket.on('bidding-time', callback)
    socket.on('bidding', callback)
  }

  componentWillUnmount() {
    const { callback } = this.props
    const socket = this.context
    socket.off('bidding-time', callback)
    socket.off('bidding', callback)
  }

  render() {
    return false
  }
}
